export default __webpack_public_path__ + "static/kiefer-video-b669e0704b7dea186051d881ae7f0d4d.mp4";